import React, { useCallback, useState } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../routing/helpers/router';
import colors from '../../../../../constants/colors';
import errorHandler from '@/layout/components/error/ErrorHandler';
import Translator from '../../../../components/helpers/Translator';

export default function ToggleValidatePeriod({ resourceObligation }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const [validated, setValidated] = useState(
    resourceObligation?.obligation?.nextDateDefaultSettings?.validated
  );

  // > TOGGLE VALIDATE PERIOD
  const toggleValidatePeriod = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_resourceManager_resourceObligation_prevision_togglePeriodValidation"
          ),
          {
            moduleBridgeHex,
            resourceObligationID: resourceObligation.id,
          }
        )
        .then(({ data }) => {
          setValidated(data);
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, resourceObligation]
  );
  // < TOGGLE VALIDATE PERIOD

  return (
    <AppRemixIcon
      icon={validated ? 'checkbox' : 'error-warning'}
      size={12}
      className="validated mr-1 pointer"
      color={validated ? colors.success : colors.danger}
      filled={!validated}
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-resourceManager"
          name={
            validated
              ? 'resource.validated.periodicity'
              : 'resource.frequency.pending.validation'
          }
        />
      )}
      onClick={() => toggleValidatePeriod()}
    />
  );
}
